import gql from "graphql-tag";

export const SEND_CHECKOUT_LINK_EVENT = gql`
  mutation requestSendCheckoutLink($invoiceId: ID!) {
    requestSendCheckoutLink(invoiceId: $invoiceId)
  }
`;
